import { Model } from "pinia-orm";
import { CertificationProjectStep, Examination, CertipersUser, UserSession } from "@/models";

export default class ExaminationDecision extends Model {
  static entity = "examinationDecisions";
  static primaryKey = "uuid";

  static fields() {
    return {
      uuid: this.uid(""),
      createdAt: this.string(""),
      updatedAt: this.string(""),
      examDecision: this.boolean(null),
      adminExamDecision: this.boolean(null),
      superadminExamDecision: this.boolean(null),
      adminExamDecisionLevel: this.string(""),
      superadminExamDecisionLevel: this.string(""),
      correctionRemarks: this.number(null),
      correctionDifferences: this.number(null),
      correctionCriticalDifferences: this.number(null),
      customDate: this.string(""),
      adminModifiedAt: this.string(""),
      superadminModifiedAt: this.string(""),
      isDisplayed: this.boolean(true),
      ratingGridDocumentUuid: this.string(""),
      questionnaireSessionDocumentUuid: this.string(""),
      additionalDocuments: this.attr([]),

      // Foreign keys
      modifiedByUuid: this.string(""),
      modifiedByData: this.belongsTo(CertipersUser, "modifiedByUuid"),
      adminModifiedByUuid: this.string(""),
      adminModifiedByData: this.belongsTo(CertipersUser, "adminModifiedByUuid"),
      superadminModifiedByUuid: this.string(""),
      superadminModifiedByData: this.belongsTo(CertipersUser, "superadminModifiedByUuid"),

      certificationProjectStepUuid: this.string(""),
      certificationProjectStepData: this.belongsTo(
        CertificationProjectStep,
        "certificationProjectStepUuid",
      ),
      examinationUuid: this.string(""),
      examinationData: this.belongsTo(Examination, "examinationUuid"),
      userSessionsList: this.hasMany(UserSession, "examinationDecisionUuid"),
    };
  }

  // INFO - AG 12/02/2025 - In practice, a ExaminationDecision will always have one UserSession,
  // but the backend model can allow many UserSession object for the same ExaminationDecision.
  // This function returns the last user_session base on createdAt
  get lastUserSession() {
    if (!this.userSessionsList) return null;
    const userSessionsOrdered =
      this.userSessionsList.length > 1
        ? this.userSessionsList
            .slice()
            .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
        : this.userSessionsList;

    return userSessionsOrdered.at(0);
  }
}
